import store from '../store'
import {
  goErrorPage
} from 'actions/routing'
import {
  setError,
  clearError
} from 'actions/onboarding'
import { SERVER_ERROR } from 'utils/errorTypes'
import { setInvalidOnboardingToken, setInvalidSecureDocUploaderToken } from 'utils/tokens'
import { redirect } from 'redux-first-router'
import bugsnag from 'bugsnag'

const handledErrors = ['TokenValidationError', 'InternalServerError']

const setInvalidToken = (feature) => {
  if (feature === 'onboarding') {
    setInvalidOnboardingToken()
  } else if (feature === 'secure_doc_uploader') {
    setInvalidSecureDocUploaderToken()
  }
}

export const handleError = (error) => {
  if (canHandleError(error)) {
    handleErrorHelper(error)
  }
}

const canHandleError = error => handledErrors.includes(error.name)

const handleErrorHelper = (error) => {
  bugsnag.notify(error)
  if (error.name === 'TokenValidationError') {
    setInvalidToken(error.feature)
    store.dispatch(clearError()) // It will show default error message
    store.dispatch(redirect(goErrorPage()))
  } else if (error.name === 'InternalServerError') {
    store.dispatch(setError(SERVER_ERROR))
    store.dispatch(redirect(goErrorPage()))
  }
}

export default {
  handleError,
}



// WEBPACK FOOTER //
// ./src/utils/apiErrorHandler.js